import { useQuery } from '@tanstack/react-query';

import { HintCoverageMatrixParams, getHintCoverageMatrix } from '~/services/ConnectionGoogleService';

export const hintCoverageQueryKeys = {
  all: ['hintCoverage'] as const,
  matrix: (params: HintCoverageMatrixParams) => [...hintCoverageQueryKeys.all, 'matrix', params] as const,
};

export function useGetHintCoverageMatrix(params: HintCoverageMatrixParams) {
  return useQuery({
    queryKey: hintCoverageQueryKeys.matrix(params),
    queryFn: async () => {
      const response = await getHintCoverageMatrix(params);
      return response.result;
    },
    enabled: !!params.accountType,
  });
}
